import search from "./search";

export function filterCatalog(term, catalogById) {
  const catalog = Object.keys(catalogById).map(id => catalogById[id]);
  if (!term) {
    return catalog;
  }
  const results = new Set();
  const matching = catalog.filter(item => search(item.name, term));

  if (matching.length === 0) {
    return [];
  }

  matching.forEach(item => results.add(item.id));
  matching.filter(item => item.parentId != null)
    .flatMap(item => getParents(item, catalogById))
    .filter(item => !!item)
    .forEach(item => results.add(item.id));

  return Array.from(results).map(id => catalogById[id]);
}

export function buildCatalogTree(catalog) {
  return catalog
    .sort((a, b) => a.name.localeCompare(b.name))
    .filter(item => !item.parentId).map(item => buildTreeFromNode(item, catalog));
}

export function buildCatalogMap(catalog) {
  return catalog.reduce((map, item) => {
    map[item.id] = item;
    return map;
  }, {});
}

function buildTreeFromNode(item, catalog) {
  return {
    ...item,
    title: item.name,
    subtitle: item.type.name,
    expanded: true,
    children: getChildren(item, catalog).map(child => buildTreeFromNode(child, catalog))
  };
}

function getChildren(item, catalog) {
  return catalog.filter(child => child.parentId === item.id);
}

export function getParents(item, catalogById) {
  const path = [];

  while (item && item.parentId) {
    item = catalogById[item.parentId];
    path.push(item);
  }

  return path;
}

export function normalizeTree(tree, parentId = null) {
  return {
    ...tree,
    parentId,
    children: tree.children.map(child => normalizeTree(child, tree.id))
  };
}

export function flattenTree(tree) {
  return tree
    .map(({children, ...item}) => {
      if(children.length < 1) {
        return [item];
      }

      return [item, ...flattenTree(children)];
    })
    .reduce((flatMap, next) => flatMap.concat(next), []);
}

export function buildNameListFromTree(baseName, parentId, tree) {
  return tree.reduce((list, item) => {
    const rootName = baseName ? baseName + " → " : "";
    const id = parentId ? parentId + ", " : '';
    list.push({name: rootName + item.name, id: id + item.id});
    return list.concat(buildNameListFromTree(rootName + item.name, id + item.id, item.children));
  }, []);
}

export function getFriendlyCatalogPathName(item, catalogById) {
  const path = [item];

  while (item.parentId) {
    if (!catalogById[item.parentId]) {
      break;
    }

    item = catalogById[item.parentId];
    path.push(item);
  }

  return path.reverse().map(item => item.name).join(' → ');
}